import React from 'react';
import { useIntl } from 'react-intl';

import { BodyCopy } from '@xingternal/typography';

import { useSerpsMatch, useTopCategories } from '../../hooks';
import { capitalizeFirstLetter } from '../../utils';
import { useTopSubcategories } from '../top-subcategories/use-top-subcategories';
import { CitiesFormattedMessage } from './cities-formatted-message';
import { SkillsFormattedMessage } from './skills-formatted-message';

import { CitiesQAWrapper, Container, Question, StyledCard, Title } from './top-cities-skills.styles';

export const TopCitiesSkills: React.FC = () => {
  const { formatMessage } = useIntl();
  const serps = useSerpsMatch();
  const jobRole = capitalizeFirstLetter(serps?.categoryValue || '');
  const { listOfCities } = useTopSubcategories();
  const { relatedSkillsByJobRole } = useTopCategories();
  const skillsLength = relatedSkillsByJobRole.length;

  if (!((listOfCities.length > 0 || skillsLength > 0) && jobRole)) {
    return null;
  }

  return (
    <Container>
      <Title size="large" sizeConfined="xlarge">
        {formatMessage({ id: 'XJM_JOBS_SEO_ROLE_FAQ_HEADLINE' })}
      </Title>
      <StyledCard>
        {listOfCities.length > 0 ? (
          <CitiesQAWrapper $hasMargin={skillsLength > 0}>
            <Question size="large">
              {formatMessage(
                { id: 'XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_QUESTION' },
                {
                  jobRole,
                }
              )}
            </Question>
            <BodyCopy noMargin>{CitiesFormattedMessage(jobRole, listOfCities)}</BodyCopy>
          </CitiesQAWrapper>
        ) : null}
        {skillsLength > 0 ? (
          <>
            <Question size="large">
              {formatMessage(
                { id: 'XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_QUESTION' },
                {
                  jobRole,
                }
              )}
            </Question>
            <BodyCopy noMargin>{SkillsFormattedMessage(jobRole, relatedSkillsByJobRole)}</BodyCopy>
          </>
        ) : null}
      </StyledCard>
    </Container>
  );
};
